export default function NotFound() {
  return <div className="flex items-center justify-center min-h-screen"><div className="text-center"><h1 className="text-4xl font-bold">404</h1><p className="text-muted-foreground mt-2">Page not found</p></div></div>
}
